import {
  Form,
  NumericFormatField,
  SubmitButton,
  TextInputField,
} from '@/components';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';
import { ReservedProjectUpsertSchema } from '../_models/reserved-project';
import { RESERVED_PROJECT_CODE_MAX_VALUE } from '../constants';

type FormValues = z.infer<typeof ReservedProjectUpsertSchema>;
type InitialFormValues = Partial<FormValues>;

type Props = {
  initialValues?: InitialFormValues;
  onSubmit: (values: FormValues) => void;
};

export const ReservedProjectForm: FC<Props> = ({ initialValues, onSubmit }) => {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors, isDirty, isSubmitting, isSubmitSuccessful },
    handleSubmit,
  } = useForm<InitialFormValues, FormValues>({
    defaultValues: initialValues,
    resolver: zodResolver(ReservedProjectUpsertSchema),
  });

  return (
    <Form
      leavePageAlertCondition={{
        isDirty,
        isSubmitting,
        isSubmitSuccessful,
      }}
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
    >
      <NumericFormatField
        name="code"
        label={t('reserved-project-code')}
        control={control}
        errors={errors}
        required
        max={RESERVED_PROJECT_CODE_MAX_VALUE}
        allowNegative={false}
        disableSeparator
      />
      <TextInputField
        name="name"
        label={t('reserved-project-name')}
        control={control}
        errors={errors}
        required
      />
      <SubmitButton disabled={!isDirty} loading={isSubmitting} />
    </Form>
  );
};
